import { render, staticRenderFns } from "./ReportsGeneral.vue?vue&type=template&id=12dc22f8&scoped=true&"
import script from "./ReportsGeneral.vue?vue&type=script&lang=ts&"
export * from "./ReportsGeneral.vue?vue&type=script&lang=ts&"
import style0 from "./ReportsGeneral.vue?vue&type=style&index=0&id=12dc22f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dc22f8",
  null
  
)

export default component.exports